import { createTheme } from '@mui/material/styles';
import './ThemeTypes';

const DigibatTheme = createTheme(
    {
        palette: {
            common: {
                black: "#000000"
            },
            primary: {
                main: '#7775f2',
                light: "#a5a4f7",
                dark: "#5553c9"
            },
            secondary: {
                main: '#7b5fc7',
                light: "#a98fd8",
                dark: "#573f9a"
            },
            surface: {
                main: "#ffffffff",
            }
        }
    });

export default DigibatTheme;